module.exports = __webpack_public_path__ + "static/media/search_uniscid.5857a69c.svg";